var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import { Route, withRouter } from "react-router";
import Loading from "@irati/ui/src/Loading";
import { hangPromise } from "@irati/utils/promise";
var MountedRoutes = /** @class */ (function (_super) {
    __extends(MountedRoutes, _super);
    function MountedRoutes() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: hangPromise(),
            resolvedRoutes: function () { return null; }
        };
        return _this;
    }
    MountedRoutes.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({
            load: this.props.routes().then(function (routes) {
                _this.setState({ resolvedRoutes: routes.default });
            })
        });
    };
    MountedRoutes.prototype.render = function () {
        return this.props.children({ load: this.state.load, resolvedRoutes: this.state.resolvedRoutes });
    };
    return MountedRoutes;
}(PureComponent));
/* eslint-disable react/no-multi-comp */
var LazyLoad = /** @class */ (function (_super) {
    __extends(LazyLoad, _super);
    function LazyLoad() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyLoad.prototype.render = function () {
        var _this = this;
        var path = this.props.path;
        var _a = this.props.routeProps, routeProps = _a === void 0 ? { path: path } : _a;
        return (React.createElement(Route, { path: path, render: function () { return (React.createElement(React.Fragment, null,
                React.createElement(MountedRoutes, { routes: _this.props.routes }, function (_a) {
                    var load = _a.load, Routes = _a.resolvedRoutes;
                    return (React.createElement(Loading, { load: load },
                        React.createElement(Routes, __assign({}, routeProps))));
                }))); } }));
    };
    return LazyLoad;
}(PureComponent));
/* eslint-enable react/no-multi-comp */
export default withRouter(LazyLoad);
